import React from "react";
import MarketSidebar from "components/Market/MarketSidebar/MarketSidebar";
import MarketTile from "components/Market/MarketTile/MarketTile";

import styles from "./style.module.css";

const MarketBlueprints = (props) => {
  const { type, hideSearch } = props;

  const renderGridTiles = () => {
    const { blueprints } = props;
    return (
      <div className={styles.gridTilesTable}>
        {blueprints.map((blueprint, index) => {
          return (
            <div key={index} className={styles.gridTilesTableColumn}>
              <MarketTile data={blueprint} type={type} />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <React.Fragment>
      {hideSearch !== true && <MarketSidebar type={type} />}
      <div className={styles.boardMainContainer}>
        <div className={styles.mainContainerHeader}>Available Blueprints</div>
        <div>{renderGridTiles()}</div>
      </div>
    </React.Fragment>
  );
};

export default MarketBlueprints;
